<template>
  <div class="m-table-header__checkbox">
    <MCheckbox
      :value="allSelected"
      @input="onChange"
    />
  </div>
</template>

<script>
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';

  export default {
    name: 'MTableHeaderCheckBox',
    components: {MCheckbox},
    props: {
      allSelected: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onChange (selected) {
        this.$emit('selectAll', selected);
      }
    }
  };
</script>

<style>
  .m-table-header__checkbox .m-checkbox .m-checkbox__check-mark {
    margin: 1px;
  }
</style>
